import styled from "styled-components";

export const PoCardItemDetailsWrapper = styled.div`
background-color: #ECEFF1;
padding: 12px;
border-radius: 8px;
display: grid;
grid-template-columns: 1fr 5fr;
align-items: flex-start;
grid-gap: 8px;
.product-img{
  border-radius: 4px;
  object-fit: contain;
  max-width: 67px;
  width:100%;
  height: 67px;
  min-width: 67px;
}
.title-item {
    display: flex;
    flex-direction: column;
    .content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    p {
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0px;
    color: ${({ theme }) => theme["label-color-new"]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 100%;
    max-width: 53svw;
}
}
p.brand-text-wrapper {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 13svw;
    width: 100%;
    overflow: hidden;
    @media (min-width: 425px) {
      max-width: 83px;
    }
    @media (min-width: 450px) {
      max-width: 120px;
    }
}
.content-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 12px;
    position: relative;
    &:not(:first-child){
      margin-top: 8px;
    }
    &::after {
    content: "";
    position: absolute;
    top: 6px;
    left: 18px;
    right: 0;
    height: 8px;
    width: 1px;
    background: #E0E0E0;
    margin: auto;
}
    .items-wrapper{
      display:flex;
      grid-gap: 2px;
      &:not(:first-child){
        padding-left: 20px;
      }
      p{
        color: #808183;
        font-size: 12px;
        margin: 0;
        &:not(:first-child){
          font-weight: 600;
          color: #4E5969;
        }
      }
    }
    .items-qty-wrapper{
      display:flex;
      grid-gap: 2px;
      p{
        color: #808183;
        font-size: 12px;
        &:not(:first-child){
          font-weight: 600;
          color: #4E5969;
        }
      }
    }
}
}
img.arrow-icon{
  margin-left: auto;
}
`;